import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LimitUsage } from '../../../models/auth/new-me.model';
import { DialogBlockComponent } from './dialog-block.component';
import { DialogBlockInstance } from './dialog-block-instance.enum';

export function openDialogBlock(
    dialog: MatDialog,
    instance: DialogBlockInstance,
    limit?: LimitUsage | null,
): MatDialogRef<DialogBlockComponent> {
    return dialog.open(DialogBlockComponent, {
        data: {
            instance,
            limite: limit?.limite_mensal ?? 0,
            saldo: limit?.consumo_atual ?? 0,
            showExtrato: instance === DialogBlockInstance.LIMIT && limit?.limite_mensal != null,
        },
        width: '600px',
    });
}

export function openBlockedFeatureDialog(
    dialog: MatDialog,
    limit: LimitUsage | null | undefined,
): MatDialogRef<DialogBlockComponent> {
    if (limit == null) {
        return openDialogBlock(dialog, DialogBlockInstance.UPGRADE);
    }

    return openDialogBlock(dialog, DialogBlockInstance.LIMIT, limit);
}
